<template>
  <q-page padding>
    <div class="row q-gutter-sm">
      <div class="row col-12">
        <p class="text-h6 text-weight-bold text-brand-5 texto-titulo">
          Listagem Facial
        </p>
        <p class="q-ml-sm text-h6 text-weight-bold text-brand-5 texto-titulo">
          -
          {{
            faceSelected
              ? faceSelected.ExternalID
              : "Selecione uma Face cadastrada"
          }}
        </p>
      </div>
    </div>
    <div
      class="row col-12 q-mt-md text-brand-5 text-weight-bold q-gutter-sm items-center"
    >
      <div class="col-md-2 col-xs-8">
        <div class="q-ml-sm text-brand-5 texto-inputs">Faces cadastradas</div>

        <q-select
          v-model="faceSelected"
          dense
          outlined
          class="select q-mt-sm q-mb-sm"
          label="Digite o nome para pesquisar"
          :options="faceList"
          option-label="ExternalID"
          option-value="id"
          map-options
          @filter="filterFn"
        />
      </div>
      <q-btn
        :disable="faceSelected"
        label="Excluir Face"
        class="q-ml-sm q-mt-lg"
        color="negative"
        icon="delete"
        @click="excluirFace"
      />
    </div>
  </q-page>
</template>

<script>
import { ref, onMounted } from "vue";
import { useStore } from "vuex";
import { useQuasar } from "quasar";

export default {
  setup() {
    const store = useStore();
    const quasar = useQuasar();
    const faceList = ref([]);
    const faceSelected = ref("");

    const listarFaces = async () => {
      try {
        let response = await store.dispatch("facialStore/getFacesList");

        faceList.value = response.data.faces;
      } catch (error) {
        quasar.notify({
          message: "Erro a o encontrar faces cadastradas",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    onMounted(listarFaces);

    const excluirFace = async () => {
      try {
        await store.dispatch("facialStore/excluirFace", {
          id: faceSelected.value.ExternalID,
        });

        quasar.notify({
          message: "Face excluida com sucesso",
          color: "positive",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        listarFaces();
        faceSelected.value = "";
      } catch (error) {
        quasar.notify({
          message: "Erro a o excluir face",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    return {
      faceList,
      faceSelected,
      excluirFace,
    };
  },
};
</script>

<style scoped>
.print-container {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

video {
  width: 50%;
  height: 100%;
}
</style>
